<template>
  <div class='h-dialogContainer'>
    <form :id="formId">
      <div class='h-subscriber-inputLit'>{{$t('SubscriberIms.groupNo')}}:</div>
      <div>
        <ejs-textbox :value='obj.grpnum' v-model='obj.grpnum' name="grpnum"></ejs-textbox>
      </div>
      <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.groupName')}}:</div>
      <div>
        <ejs-textbox :value='obj.grpname' v-model='obj.grpname' name="grpname"></ejs-textbox>
      </div>
    </form>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'ImsSearchDialog',
  data() {
    return {
      formId: 'searcgFormId',
      validateObj: undefined,
      obj: {
        grpnum: '',
        grpname: '',
        grptype: -1,
        flag: 2
      }
    };
  },
  methods: {
    getFormValue() {
      return { grpnum: this.obj.grpnum, grpname: this.obj.grpname, grptype: this.obj.grptype, flag: 2 };
    },
    getData() {
      return this.obj;
    },
    clearData() {
      this.obj = { grpnum: '', grpname: '', grptype:-1, flag: 2 };
    },
    setData(data) {
      if (data) {
        this.obj = data;
      }
    },
    checkValid() {
      const checkStatus = this.validateObj.validate();
      return checkStatus;
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          grpnum: {
            regex: ['^\\d*$', this.$t('SubscriberIms.invalidInt')],
            range: [[1, 99999999], this.$t('SubscriberIms.grpnumrange')],
          },
          grpname: {
            regex: ['^[_0-9a-zA-Z\u4E00-\u9FA5]+$', this.$t('SubscriberIms.invalideChar')],
            maxLength: [15, this.$t('SubscriberIms.maxlen15')],
          }
        },
      };
      this.validateObj = new FormValidator(`#${this.formId}`, validationOption);
    },
  }
};
</script>

<style scoped>

</style>
